/*
 * @Description: 
 * @Author: zml
 * @Date: 2023-04-26 14:28:08
 * @LastEditors: pcc
 * @LastEditTime: 2023-07-19 18:00:47
 */
import request from '@/utils/request'

// 获取登录二维码
export function getLoginQRCode() {
  return request({
    url: 'admin/Weixin/GetLoginQRCode',
    method: 'get',
  })
}
//轮询检查登录状态
export function weChatLoginCheck(data) {
  return request({
    url: 'admin/Weixin/WeChatLoginCheck',
    method: 'post',
    data
  })
}

//二维码登录
export function qrCodeLogin(data) {
  return request({
    url: 'admin/Weixin/QrCodeLogin',
    method: 'post',
    data
  })
}

// 获取验证码
export function authGetSmsCode (data) {
  return request({
    url: 'admin/auth/GetSmsCode',
    method: 'post',
    data
  })
}

/**
 * 手机验证码登录
 * @param {*} data 
 * @returns 
 */
export function mobileLogin (data) {
  return request({
    url: 'admin/auth/loginByMobile',
    method: 'post',
    data
  })
}